module.exports = __webpack_public_path__ + "img/bft.39fbc5f0.png";